import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../redux/actions/loadingAction";
import { logout } from "../../../redux/actions/logoutAction";
import { useHistory } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import { Row, Col } from "react-bootstrap";

import * as API from "../../../utils/apis";

import BoxCard from "../../../components/BoxCard";
import InputSelect from "../../../components/InputSelect";
import Breadcrumb from "../../../components/Breadcrumb";
import DataTableNodata from "../../../components/DataTableNodata";
import DataTable from "../../../components/DataTable";
import ModalDiseaseType from "../../../components/Data_Management/Modal.DiseaseType";
const MySwal = withReactContent(Swal);

function Disease_Type() {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.login.result);
  const statusCheck = useSelector((state) => state.statusCheck);
  const breadcrumbPath = [
    { path: "/home", name: "หน้าหลัก" },
    {
      path: "/data-manage/web-settings/news",
      name: "บริหารจัดการข้อมูลส่วนกลาง",
    },
    { path: "/data-manage/master-data/animal-type", name: "Master Data" },
    { path: "active", name: "ชนิดโรค" },
  ];

  const initialForm = {
    animalId: "",
    status: "",
    diseaseId: "",

    idEdit: "",
    data_animalType: [],
    mode: "",

    limit: 10,
    page: 1,
    totalPages: 1,
    sortDir: "DESC",
    sortBy: "id",
    totalElements: 0,
    numberOfElements: 0,

    headTitle: [
      {
        sortBy: "id",
        name: "ลำดับ",
        sortFlg: false,
        width: "50px",
      },
      {
        sortBy: "name",
        name: "ชนิดโรค",
        sortFlg: true,
      },
      {
        sortBy: "animalTypeId",
        name: "ชนิดสัตว์",
        sortFlg: false,
      },
      {
        sortBy: "statusId",
        name: "สถานะ",
        sortFlg: true,
      },
      {
        sortBy: "isZeroReport",
        name: "ZeroReport",
        sortFlg: true,
      },
      {
        name: "จัดการ",
        sortFlg: false,
      },
    ],
  };
  const [form, setForm] = useState(initialForm);

  const initialFormJson = {
    animal: {},
  };
  const [formJson, setFormJson] = useState(initialFormJson);

  const [listDisease, setListDiseaseType] = useState([]);

  const [showDiseaseType, setshowDiseaseType] = useState(false);

  const [animalIdSelectValue, setAnimalIdSelectValue] = useState([]);
  const [animalIdList, setAnimalList] = useState([]);

  const [diseaseIdSelectValue, setDiseaseIdSelectValue] = useState([]);
  const [diseaseIdList, setDiseaseList] = useState([]);

  const [statusZeroReportSelectValue, setStatusZeroReportSelectValue] = useState([]);
  const [statusSelectValue, setStatusSelectValue] = useState([]);
  const selectStatusList = [
    { value: 1, label: "ใช้งาน" },
    { value: 2, label: "ไม่ใช้งาน" },
  ];
  const [statusList, setStatusList] = useState(selectStatusList);
  const [isClearSearch, setIsClearSearch] = useState(false);
  const [listDiseaseAll, setListDiseaseAll] = useState([]);

  useEffect(() => {
    getAnimal();
    getDisease();
    getMasterJson();
  }, []);

  useEffect(async () => {
    await getDiseaseType();
  }, [form.limit, form.page, form.sortBy, form.sortDir, isClearSearch]);

  useEffect(() => {
    getDiseaseTypeAll();
  }, [form.totalElements]);

  const getDiseaseType = async () => {
    dispatch(loading(true));
    try {
      const response = await API.getDiseaseType(
        form.animalId,
        form.diseaseId,
        form.page,
        form.limit,
        form.status,
        "",
        form.sortBy,
        form.sortDir,
        form.isZeroReport
      );
      const data = await response?.data;
      if (response.status === 200) {
        let diseaseArray = [];
        data.content.forEach((element) => {
          diseaseArray.push({
            value: element.id,
            label: element.name,
          });
        });

        dispatch(loading(false));
        setForm({
          ...form,
          totalPages: data.totalPages,
          totalElements: data.totalElements,
          numberOfElements: data.numberOfElements,
        });
        setListDiseaseType(data.content);
      }
    } catch (error) {
      dispatch(loading(false));
      if (error.response && error.response.status === 401) {
        dispatch(logout({ history }));
      }
      console.log(error);
    }
  };
  const getDiseaseTypeAll = async () => {
    try {
      const response = await API.getDiseaseType(
        form.animalId,
        form.diseaseId,
        form.page,
        form.totalElements,
        form.status,
        "",
        form.sortBy,
        form.sortDir
      );
      const data = await response?.data;
      if (response.status === 200) {
        let diseaseArray = [];
        data.content.forEach((element) => {
          diseaseArray.push({
            value: element.id,
            label: element.name,
          });
        });

        dispatch(loading(false));
        setListDiseaseAll(data.content);
      }
    } catch (error) {
      dispatch(loading(false));
      console.log(error);
    }
  };

  const getMasterJson = async () => {
    const params = ["animalType"];
    try {
      const response = await API.getMasterJson(params);
      const data = await response?.data;
      if (response.status === 200) {
        setFormJson({
          ...formJson,
          animal: data.animalType,
        });
      }
    } catch (error) {
      dispatch(loading(false));
      console.log(error);
    }
  };

  const getDisease = async () => {
    try {
      const response = await API.getDiseaseType("",
      "",
      "1",
      "1000",
      "1",
      "",
      "name",
      "ASC");
      const data = await response?.data;
      if (response.status === 200) {
        let diseaseArray = [];
        data.content.forEach((element) => {
          diseaseArray.push({
            value: element.id,
            label: element.name,
          });
        });
        setDiseaseList(diseaseArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAnimal = async () => {
    try {
      const response = await API.getAnimal();
      const data = await response?.data;
      if (response.status === 200) {
        let animalArray = [];
        data.content.forEach((element) => {
          animalArray.push({
            value: element.id,
            label: element.name,
          });
        });
        setAnimalList(animalArray);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getStatusColor = (idStatus) => {
    let statusColor;
    if (statusCheck && statusCheck.length > 0) {
      statusCheck.map((item, index) => {
        if (item.id === idStatus) {
          statusColor = (
            <div className="d-flex justify-content-center">
              <div
                style={{ background: item.color }}
                className="box-status font14 px-4 text-center text-white"
              >
                <span>{item.status}</span>
              </div>
            </div>
          );
        }
        return true;
      });
    }
    return statusColor;
  };

  const getFilter = async (type, isChange1, isChange2) => {
    if (type === "page") {
      setForm({
        ...form,
        page: isChange1,
      });
    } else if (type === "limit") {
      setForm({
        ...form,
        page: 1,
        limit: isChange1,
      });
    } else if (type === "filter") {
      setForm({
        ...form,
        sortBy: isChange1,
        sortDir: isChange2,
        page: 1,
      });
    }
  };

  const buttonAddDisease = () => {
    return (
      <div className="d-flex justify-content-end ">
        <button
          className="btn btn-add text-white"
          onClick={() => toAddAddDisease()}
          disabled={user?.userGroup.mcreate === "n"}
        >
          <i className="fas fa-plus mr-1 "></i>เพิ่มชนิดโรค
        </button>
      </div>
    );
  };

  const toSearch = () => {
    setForm({ ...form, page: 1 });
    setIsClearSearch(!isClearSearch);
  };

  const clearSearch = () => {
    setForm(initialForm);
    setAnimalIdSelectValue([]);
    setDiseaseIdSelectValue([]);
    setStatusSelectValue([]);
    setStatusZeroReportSelectValue([]);
    setIsClearSearch(!isClearSearch);
  };

  const buttonSearch = () => {
    return (
      <>
        <button className="btn btn-danger mr-2" onClick={() => clearSearch()}>
          ล้างข้อมูล
        </button>
        <button className="btn btn-success" onClick={() => toSearch()}>
          ค้นหา
        </button>
      </>
    );
  };

  const toAddAddDisease = () => {
    setForm({ ...form, mode: "add", idEdit: "" });
    setshowDiseaseType(true);
  };

  const editModalDiseaseType = (id) => {
    setForm({ ...form, mode: "edit", idEdit: id });
    setshowDiseaseType(true);
  };

  const delDiseaseType = async (id) => {
    MySwal.fire({
      text: `ยืนยันที่จะลบ `,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response = await API.deleteDiseaseType(id);
          if (response.status === 200) {
            MySwal.fire({
              text: `ลบสำเร็จ`,
              icon: "success",
              confirmButtonText: "ตกลง",
            }).then(async (result) => {
              await getDiseaseType();
            });
          }
        } catch (error) {
          dispatch(loading(false));
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: `ลบไม่สำเร็จ กรุณาลองใหม่อีกครั้ง`,
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error", error);
        }
      }
    });
  };

  const addSaveDiseasetType = (data) => {
    const arrayAnimal = [];
    if (data.disease && data.disease.data_animaltype.length > 0) {
      data.disease.data_animaltype.map((item, i) => {
        arrayAnimal.push(item.animalTypeId);
        return true;
      });
    }
    const datadisease = {
      name: data.disease.disease_name,
      description: data.disease.disease_detail,
      code: data.disease.disease_code,
      statusId: data.disease.status,
      animalIds: arrayAnimal,
      isZeroReport: data.disease.isZeroReport,
    };

    MySwal.fire({
      text: `ต้องการบันทึก `,
      icon: "question",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "ยกเลิก",
      confirmButtonText: "ตกลง",
    }).then(async (result) => {
      if (result.value) {
        try {
          const response =
            data.mode === "add"
              ? await API.saveDiseaseType(datadisease)
              : await API.updateDiseaseType(
                  data.disease.disease_id,
                  datadisease
                );
          if (response.status === 200) {
            await getDiseaseType();
          }
        } catch (error) {
          dispatch(loading(false));
          if (error.response && error.response.status === 401) {
            dispatch(logout({ history }));
          } else {
            MySwal.fire({
              text: "บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
              icon: "warning",
              confirmButtonText: "ตกลง",
            });
          }
          console.log("error++++++", error);
        }
      }
    });
  };

  const renderTableAnimalType = (data) => {
    if (data.length > 0) {
      return data.map((item, i) => (
        <tr key={i}>
          <td className="text-center">
            {form.limit * (form.page - 1) + (i + 1)}
          </td>
          <td>{item.name}</td>
          <td className="p-wrap2">
            {item.animalIds && item.animalIds.length > 0
              ? item.animalIds.map((animal, a) => {
                  if (item.animalIds.length === Number(a) + 1) {
                    return <span key={a}>{formJson.animal[animal]} </span>;
                  } else {
                    return <span key={a}>{formJson.animal[animal]}, </span>;
                  }
                })
              : "-"}
          </td>

          <td className="text-center">{getStatusColor(item.statusId)}</td>
          <td className="text-center">{getStatusColor(item.isZeroReport)}</td>

          <td className="d-flex justify-content-center">
            <button
              className="btn btn-add mr-2 "
              onClick={() => editModalDiseaseType(item.id)}
              disabled={
                user?.userGroup.mupdate === "n" && user?.userGroup.mview === "n"
              }
            >
              <img className="icon-btn" src="/svg/btn-edit.svg" alt="edit" />
            </button>
            <button
              className="btn btn-del mr-2 "
              onClick={() => delDiseaseType(item.id)}
              disabled={user?.userGroup.mdelete === "n"}
            >
              <img className="icon-btn " src="/svg/btn-del.svg" alt="del" />
            </button>
          </td>
        </tr>
      ));
    } else {
      return <DataTableNodata colSpan={6} />;
    }
  };

  return (
    <div className=" ">
      <div className="pl-4 bg-white ml30 d-flex">
        <div className="mr-auto p-2 ">
          <Breadcrumb data={breadcrumbPath} />
        </div>
      </div>

      <div className="bg-gray-light ">
        <div className="px-4 pt-3 container-fixed-footer ">
          <BoxCard classNameBox="" title="ตัวกรอง" headRight={buttonSearch()}>
            <Row>
            <Col lg={2} md={6} sm={12} xs={12}>
                <InputSelect
                  title="ชนิดโรค"
                  star={false}
                  placeholder="กรุณาเลือก"
                  idName="title"
                  classLabel="normal"
                  selectValue={diseaseIdSelectValue}
                  optionsList={diseaseIdList}
                  handleSelectValue={(value) =>
                    setDiseaseIdSelectValue([
                      { value: value.value, label: value.label },
                    ])
                  }
                  handleChange={(value) =>
                    setForm({ ...form, diseaseId: value.value })
                  }
                />
              </Col>
              <Col lg={2} md={6} sm={12} xs={12}>
                <InputSelect
                  title="ชนิดสัตว์"
                  star={false}
                  placeholder="กรุณาเลือก"
                  idName="title"
                  classLabel="normal"
                  selectValue={animalIdSelectValue}
                  optionsList={animalIdList}
                  handleSelectValue={(value) =>
                    setAnimalIdSelectValue([
                      { value: value.value, label: value.label },
                    ])
                  }
                  handleChange={(value) =>
                    setForm({ ...form, animalId: value.value })
                  }
                />
              </Col>

              <Col lg={2} md={6} sm={12} xs={12}>
                <InputSelect
                  title="สถานะ"
                  star={false}
                  placeholder="กรุณาเลือก"
                  idName="title"
                  classLabel="normal"
                  selectValue={statusSelectValue}
                  optionsList={statusList}
                  handleSelectValue={(value) =>
                    setStatusSelectValue([
                      { value: value.value, label: value.label },
                    ])
                  }
                  handleChange={(value) =>
                    setForm({ ...form, status: value.value })
                  }
                />
              </Col>
              <Col lg={2} md={6} sm={12} xs={12}>
                <InputSelect
                  title="Zero Report"
                  star={false}
                  placeholder="กรุณาเลือก"
                  idName="title"
                  classLabel="normal"
                  selectValue={statusZeroReportSelectValue}
                  optionsList={statusList}
                  handleSelectValue={(value) =>
                    setStatusZeroReportSelectValue([
                      { value: value.value, label: value.label },
                    ])
                  }
                  handleChange={(value) =>
                    setForm({ ...form, isZeroReport: value.value })
                  }
                />
              </Col>
            </Row>
          </BoxCard>

          <BoxCard
            title="รายการข้อมูลชนิดโรค"
            classNameBox="mt-4"
            headRight={buttonAddDisease()}
          >
            <DataTable
              headColumns={form.headTitle}
              totalPages={form.totalPages}
              page={form.page}
              limit={form.limit}
              sortDir={form.sortDir}
              sortBy={form.sortBy}
              getLimit={(limit) => getFilter("limit", limit)}
              getFilter={(sortBy, sortDir) =>
                getFilter("filter", sortBy, sortDir)
              }
              getPage={(page) => getFilter("page", page)}
              totalItems={form.totalElements}
              numberOfItems={form.numberOfElements}
              isClear={isClearSearch}
            >
              {renderTableAnimalType(listDisease)}
            </DataTable>
          </BoxCard>
          {showDiseaseType && (
            <ModalDiseaseType
              show={showDiseaseType}
              close={() => setshowDiseaseType(false)}
              save={(value) => addSaveDiseasetType(value)}
              mode={form.mode}
              idEdit={form.idEdit}
              listDisease={listDiseaseAll}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Disease_Type;
